// src/pages/admin/CompanyRegulationsPage.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";

// ฟอร์ม “เชิญประชุมแก้ไขข้อบังคับบริษัท”
import CompanyRegulationsForm from "../../forms/meeting/MeetingInvitationforAmendmentofCompanyRegulations/MeetingInvitationforAmendmentofCompanyRegulations";

function CompanyRegulationsPage() {
  return (
    <FormWrapper
      title="เชิญประชุมแก้ไขข้อบังคับบริษัท"
      FormComponent={CompanyRegulationsForm}
      formKey="company-regulations-amendment"
    />
  );
}

export default CompanyRegulationsPage;
